import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51376a02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "assignment-cancel-form",
  style: {"margin-left":"10px","margin-right":"10px"}
}
const _hoisted_2 = { class: "row bottom_border" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold cancel-header1" }, "Select Cancellation Type")
  ])
], -1))
const _hoisted_4 = { class: "col reset-padding" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_7 = { class: "col reset-padding" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "N/A", -1))
const _hoisted_10 = { class: "col reset-padding" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "U/A - Employee Made Contact", -1))
const _hoisted_13 = { class: "col reset-padding" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "U/A - No Show / No Call", -1))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold cancel-header1" }, "Select Cancel Reason")
  ])
], -1))
const _hoisted_18 = {
  id: "divCancelReasons",
  class: "col"
}
const _hoisted_19 = ["data-reason-id", "onClick"]
const _hoisted_20 = { class: "row bottom_border" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group" })
], -1))
const _hoisted_22 = { class: "col reset-padding" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-sm-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold cancel-header1" }, "Optional - Replace with Non-Productive Shift")
], -1))
const _hoisted_27 = {
  key: 0,
  class: "form-group divPTOBalance",
  style: {"text-align":"center","font-size":"14px"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { style: {"margin-bottom":"0"} }, "PTO Balance", -1))
const _hoisted_29 = {
  id: "pto_balance",
  style: {"border-bottom":"1px solid grey","width":"40%","display":"inline-block","color":"gray","font-weight":"700"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { style: {"margin-bottom":"0"} }, "Pay Period Accural", -1))
const _hoisted_31 = {
  id: "pay_period_accured",
  style: {"border-bottom":"1px solid grey","width":"40%","display":"inline-block","font-weight":"700","color":"gray"}
}
const _hoisted_32 = {
  key: 0,
  class: "row txtLeft mt-3"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-sm-6",
  style: {"padding":"0"}
}, "Pay Period Start", -1))
const _hoisted_34 = {
  class: "col-sm-6",
  style: {}
}
const _hoisted_35 = { id: "pay_period_start" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-sm-6",
  style: {"padding":"0"}
}, "PTO Balance", -1))
const _hoisted_37 = {
  class: "col-sm-6",
  style: {}
}
const _hoisted_38 = { id: "pto_balance_hours" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-sm-6",
  style: {"padding":"0px"}
}, "Less Approved PTO", -1))
const _hoisted_40 = {
  class: "col-sm-6",
  style: {}
}
const _hoisted_41 = { id: "less_approved_pto" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-sm-6",
  style: {"padding":"0"}
}, "Estimated PTO Hrs", -1))
const _hoisted_43 = {
  class: "col-sm-6",
  style: {}
}
const _hoisted_44 = { id: "estimated_pto" }
const _hoisted_45 = {
  class: "col",
  id: "divShifts"
}
const _hoisted_46 = {
  key: 0,
  class: "divShifts"
}
const _hoisted_47 = ["data-KronosPayCode", "data-shift-id", "data-shiftStartTime", "onClick"]
const _hoisted_48 = {
  class: "row",
  style: {"align-items":"center"}
}
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<div class=\"col-sm-3\" data-v-51376a02><div class=\"form-group\" data-v-51376a02><label class=\"font-weight-bold\" data-v-51376a02></label></div></div><div class=\"col reset-padding\" data-v-51376a02><div class=\"form-group\" data-v-51376a02><label class=\"font-weight-bold\" data-v-51376a02>Start Time:</label></div></div>", 2)
const _hoisted_51 = { class: "col-sm-2" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Duration: ")
  ])
], -1))
const _hoisted_54 = { class: "col-sm-5 txtLeft" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" })
  ])
], -1))
const _hoisted_58 = { class: "col" }
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "assignment-cancel" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_vue_timepicker = _resolveComponent("vue-timepicker")!
  const _component_neu_button = _resolveComponent("neu-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["btn-cancellation-type", [_ctx.isFacilityCanceled ? 'selected' : '']]),
            "data-category": "2",
            "data-unscheduled-absence": "0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCancellationType('FacilityCanceled',2)))
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'hospital'],
                size: "lg",
                class: "mr-2"
              }),
              _createTextVNode("Facility Canceled")
            ]),
            _hoisted_6
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass(["btn-cancellation-type", [_ctx.isEmployeeCanceledNA ? 'selected' : '']]),
            "data-category": "1",
            "data-unscheduled-absence": "0",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancellationType('EmployeeCanceledNA',1)))
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'user'],
                size: "lg",
                class: "mr-2"
              }),
              _createTextVNode("Employee Canceled")
            ]),
            _hoisted_9
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass(["btn-cancellation-type", [_ctx.isEmployeeCanceledEMC ? 'selected' : '']]),
            "data-category": "1",
            "data-unscheduled-absence": "1",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCancellationType('EmployeeCanceledEMC',1)))
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'user'],
                size: "lg",
                class: "mr-2"
              }),
              _createTextVNode("Employee Canceled")
            ]),
            _hoisted_12
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(["btn-cancellation-type", [_ctx.isEmployeeCanceledNSNC ? 'selected' : '']]),
            "data-category": "1",
            "data-unscheduled-absence": "2",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onCancellationType('EmployeeCanceledNSNC',1)))
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'user'],
                size: "lg",
                class: "mr-2"
              }),
              _createTextVNode("Employee Canceled")
            ]),
            _hoisted_15
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deptCancelReasons, (cancelRsn) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["btn-cancellation-reason", [cancelRsn.isSelected ? 'selected': '']]),
            key: cancelRsn,
            "data-reason-id": cancelRsn.reasonId,
            onClick: ($event: any) => (_ctx.onCancellationReasonClick(cancelRsn.reasonId))
          }, [
            _createElementVNode("div", null, _toDisplayString(cancelRsn.reason), 1)
          ], 10, _hoisted_19))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "txtCancelComment",
            placeholder: "Enter Comment",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.txtCancelComment) = $event)),
            class: "inputBorder text-comment"
          }, null, 512), [
            [_vModelText, _ctx.txtCancelComment]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        (_ctx.showPTOBalance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("h4", _hoisted_29, _toDisplayString(parseFloat(_ctx.PTOBalanceData.ptoBalance).toFixed(2)), 1),
              _hoisted_30,
              _createElementVNode("h4", _hoisted_31, _toDisplayString(parseFloat(_ctx.PTOBalanceData.payPeriodAccrual).toFixed(2)), 1),
              (_ctx.PTOBalanceData.ptoBalanceAccrual != null && _ctx.PTOBalanceData.ptoBalanceAccrual.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.payPeriodStart), 1)
                    ]),
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, _toDisplayString(parseFloat(_ctx.PTOBalanceData.ptoBalanceAccrual[0].ptoBalance).toFixed(2)), 1),
                      _createTextVNode(" hours")
                    ]),
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.PTOBalanceData.ptoBalanceAccrual[0].lessFsApprovalPto), 1),
                      _createTextVNode(" hours")
                    ]),
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("span", _hoisted_44, _toDisplayString(parseFloat(_ctx.PTOBalanceData.ptoBalanceAccrual[0].estPtoHours).toFixed(2)), 1),
                      _createTextVNode(" hours")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_45, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deptShifts, (dept) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: dept }, [
            (dept.productiveId === _ctx.NON_PRODUCTIVE && !dept.disabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn-replace-non-productive-shift", [dept.isSelected ? 'selected': '']]),
                    "data-KronosPayCode": dept.KronosPayCode,
                    "data-shift-id": dept.deptShiftId,
                    "data-shiftStartTime": dept.shiftStartTime,
                    onClick: ($event: any) => (_ctx.nonProductiveShiftClick(dept.deptShiftId))
                  }, [
                    _createElementVNode("div", null, _toDisplayString(dept.code), 1),
                    _createElementVNode("span", null, _toDisplayString(dept.deptShiftDescription), 1)
                  ], 10, _hoisted_47)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _hoisted_49,
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          (_openBlock(), _createBlock(_component_vue_timepicker, {
            format: "h:mm A",
            "minute-interval": 30,
            modelValue: _ctx.txtStartTime,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.txtStartTime) = $event)),
            key: _ctx.counterTime,
            "manual-input": "",
            "auto-scroll": "",
            "close-on-complete": ""
          }, null, 8, ["modelValue"]))
        ])
      ]),
      _hoisted_53,
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "txtDurationHours",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.txtDurationHours) = $event)),
            placeholder: "Hrs",
            style: {"width":"50px"},
            class: "inputBorder mr-2"
          }, null, 512), [
            [_vModelText, _ctx.txtDurationHours]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "txtDurationMins",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.txtDurationMins) = $event)),
            placeholder: "Mins",
            style: {"width":"50px"},
            class: "inputBorder"
          }, null, 512), [
            [_vModelText, _ctx.txtDurationMins]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _hoisted_57,
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createVNode(_component_neu_button, {
            type: "button",
            fill: "raised",
            id: "btnCancelAssignment",
            style: {"width":"200px","display":"block","margin":"0 auto"},
            onClick: _ctx.CancelAssignment
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Proceed with Cancellation ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _hoisted_60
  ]))
}